<script setup lang="ts">
import Main from './views/Main.vue';

// INFO
// Chargement direct de la page principale
// On peut prevoir à ce niveau : 
// - une page d'information
// - une page de maintenance
// Ces informations peuvent être fournies par un JSON de configuration editoriale 
</script>

<template>
  <Main />
</template>
